import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/utils/dateLocale"; // must run before any component renders
import App from "@/App";

// Suppress ResizeObserver loop errors (common with dropdown components)
// This is a known non-critical warning that doesn't affect functionality
if (typeof window !== 'undefined') {
  // Suppress via error event
  window.addEventListener('error', (e) => {
    if (e.message?.includes?.('ResizeObserver loop') || 
        e.message?.includes?.('ResizeObserver loop completed')) {
      e.stopImmediatePropagation();
      e.stopPropagation();
      e.preventDefault();
      return true;
    }
  }, true);

  // Suppress via unhandledrejection
  window.addEventListener('unhandledrejection', (e) => {
    if (e.reason?.message?.includes?.('ResizeObserver')) {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  });

  // Override ResizeObserver to catch errors
  const OriginalResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class ResizeObserver extends OriginalResizeObserver {
    constructor(callback) {
      super((entries, observer) => {
        // Use requestAnimationFrame to avoid the loop error
        window.requestAnimationFrame(() => {
          try {
            callback(entries, observer);
          } catch (e) {
            // Silently ignore ResizeObserver errors
          }
        });
      });
    }
  };
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register Service Worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then(
      (reg) => {
        console.log('SW registered:', reg.scope);

        // Force the SW to check for an updated version on every page load.
        // Without this the browser sometimes holds onto a stale SW for hours.
        reg.update().catch(() => {});

        // Re-check every 60s while the page is open
        setInterval(() => { reg.update().catch(() => {}); }, 60 * 1000);

        // When a new SW is installed and waiting, tell it to take over
        // and reload so the user sees the new code immediately.
        reg.addEventListener('updatefound', () => {
          const newSw = reg.installing;
          if (!newSw) return;
          newSw.addEventListener('statechange', () => {
            if (newSw.state === 'installed' && navigator.serviceWorker.controller) {
              newSw.postMessage('skipWaiting');
            }
          });
        });
      },
      (err) => console.log('SW registration failed:', err)
    );

    // When the controlling SW changes (i.e. a new version took over) — reload once
    let reloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  });
}
